import React, {Component} from 'react';
import Translate, {t} from "../../../../../../../components/Translate";
import Input from "../../../../../../../components-new/form/Input";
import config from "../../../../../../../config";
import SilverButton from "../../../../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../../../../components-new/buttons/BlueButton";
import {handleValueChange} from "../../../../../../../utils/ComponentUtilFunctions";
import {generalModalStyles} from "../../../../../../../utils/General";
import DropdownSelect from "../../../../../../../components-new/form/DropdownSelect";
import Tabs from "../../../../../../../components-new/ui/Tabs";
import Modal from '../../../../../../../components-new/ui/Modal';
import {fetchCompanyRequested} from "../../../../../../../services/company/action";
import {connect} from "react-redux";
import ImportIcon from "../../../../../../../assets/icons/ImportIcon";
import XIcon from "../../../../../../../assets/icons/XIcon";
import BotIcon from "../../../../../../../assets/icons/BotIcon";

const customStyles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '420px',
        maxWidth: '100%',
    },
};

class CreateClientModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            domain: '',
            image: '',
            type: config.companyTypeMap.scenario,
            originalClient: {},
            importedBot: null,
            importedFileName: '',
            isSubmitting: false
        };
        this.handleValueChange = handleValueChange.bind(this);
        this.importInputRef = React.createRef();

        // A plain field, not state: two Enter presses land in the same batch, and
        // setState has not applied by the time the second one is handled, so a
        // state flag lets both through - which is how two identical bots were
        // created. The state below is for the button's appearance only.
        this.submitting = false;
    }

    getClientFromState = () => {
        const {
            name, domain, image, type, originalClient
        } = this.state;
        return {
            name,
            domain,
            image,
            type,
            originalClientId: originalClient.id
        };
    };


    handleImportFileChange = (event) => {
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            try {
                const importedBot = JSON.parse(reader.result);
                this.setState((prevState) => ({
                    importedBot,
                    importedFileName: file.name,
                    name: prevState.name || (importedBot.company && importedBot.company.name) || '',
                    originalClient: {},
                }));
            } catch (e) {
                this.setState({importedBot: null, importedFileName: ''});
            }
        };
        reader.readAsText(file);
        event.target.value = '';
    };

    cancelImport = () => {
        this.setState({
            name: '',
            domain: '',
            image: '',
            type: config.companyTypeMap.scenario,
            originalClient: {},
            importedBot: null,
            importedFileName: ''
        });
    };

    handleTypeChange = (type) => {
        // an imported bot is always a scenario one, so switching to smart drops it
        if (type === config.companyTypeMap.smart) {
            this.cancelImport();
        }
        this.setState({type});
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const {name, importedBot} = this.state;
        const {createClient, importClient, fetchCompany} = this.props;

        if (this.submitting) return;
        this.submitting = true;
        this.setState({isSubmitting: true});

        const request = importedBot
            ? importClient(name, importedBot)
            : createClient(this.getClientFromState());

        request
            .then(() => {
                this.setState({name: '', importedBot: null, importedFileName: ''});
                fetchCompany();
            })
            .finally(() => {
                this.submitting = false;
                this.setState({isSubmitting: false});
            });
    };

    render() {
        const {
            name, type, originalClient, importedBot, importedFileName, isSubmitting
        } = this.state;
        const {
            closeCreateClientModal,
            user,
            tariff,
            clients,
            isOpen,
            onRequestClose,
        } = this.props;
        const {features} = tariff;
        const hasAi = features.includes(config.features.AI);

        return (
            <Modal
                closeTimeoutMS={config.closeTimeoutMS}
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                onCancel={closeCreateClientModal}
                style={{
                    ...generalModalStyles.convHeaderModalStyles,
                    content: {
                        ...generalModalStyles.convHeaderModalStyles.content,
                        width: '468px',
                        maxWidth: 'calc(100vw - 32px)',
                    },
                }}
                title={<Translate text="createNewBot"/>}
                description={<Translate text="createNewBotDescription"/>}
                headerIcon={<BotIcon width={20} height={20} stroke="var(--ds-fg-secondary)"/>}
                headerSeparator
                footerSeparator
                allowContentOverflow
                footer={<React.Fragment>
                    <SilverButton type="button" width="auto" height="40px"
                                  disabled={isSubmitting} onClick={closeCreateClientModal}>
                        <Translate text="close"/>
                    </SilverButton>
                    <BlueButton type="button" width="auto" height="40px" onClick={this.handleSubmit}
                                disabled={name === '' || isSubmitting} loading={isSubmitting}>
                        <Translate text={importedBot ? 'import' : 'create'}/>
                    </BlueButton>
                </React.Fragment>}
            >
                    <div style={customStyles.container}>
                        <div className="standard-input-label"><Translate text="botType"/></div>
                        <Tabs
                            selectedTab={type}
                            onTabChange={this.handleTypeChange}
                            fluid
                            tabs={[
                                {
                                    value: config.companyTypeMap.scenario,
                                    label: 'scenario'
                                },
                                {
                                    value: config.companyTypeMap.smart,
                                    label: 'smart',
                                    disabled: !hasAi,
                                    title: hasAi ? undefined : t({text: 'smartBotNeedsAiTariff', user})
                                }
                            ]}
                        />
                        {type === config.companyTypeMap.scenario && (
                            <div style={{display: 'flex', flexDirection: 'column', gap: '4px'}}>
                                <div className="standard-input-label"><Translate text="cloneFrom"/></div>
                                <DropdownSelect
                                    options={clients.filter(c => c.type === config.companyTypeMap.scenario)}
                                    selectedValue={""}
                                    disabled={!!importedBot}
                                    onChange={(event) => {
                                        this.setState({originalClient: event})
                                    }}
                                    renderLabel={() => {
                                        return originalClient.name
                                    }}
                                    styles={{
                                        height: '40px',
                                        width: '100%'
                                    }}
                                    childStyles={{
                                        maxHeight: '200px',
                                        overflow: 'auto'
                                    }}
                                />
                            </div>

                        )}

                        <Input
                            label={<Translate text="botName"/>}
                            required
                            placeholder={t({text: "enterBotName*", user})}
                            debounceTime={0}
                            value={name}
                            maxLength={30}
                            onChange={(e) => this.handleValueChange('name')(e.target.value)}
                            onKeyDown={(event) => {
                                if (event.key !== 'Enter') return;
                                event.preventDefault();
                                if (event.currentTarget.reportValidity()) this.handleSubmit(event);
                            }}
                            style={{height: '40px'}}
                        />

                        <input
                            ref={this.importInputRef}
                            type="file"
                            accept="application/json,.json"
                            style={{display: 'none'}}
                            onChange={this.handleImportFileChange}
                        />
                        {importedFileName && (
                            <p style={{
                                color: 'var(--ds-text-tertiary)',
                                fontSize: '12px',
                                overflowWrap: 'anywhere',
                                margin: 0
                            }}>{importedFileName}</p>
                        )}

                        {type === config.companyTypeMap.smart && (
                            <div style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                                <p style={{
                                    color: 'var(--ds-text-tertiary)',
                                    fontSize: '12px',
                                    textAlign: 'center',
                                    marginTop: '10px',
                                    marginBottom: '76px',
                                    maxWidth: '400px'
                                }}
                                >
                                    <Translate text={'smartBotCreateInfo'}/>
                                </p>
                            </div>

                        )}

                        {
                            type === config.companyTypeMap.scenario &&
                            <SilverButton
                                type="button"
                                height="40px"
                                disabled={type === config.companyTypeMap.smart}
                                onClick={() => importedBot ? this.cancelImport() : this.importInputRef.current && this.importInputRef.current.click()}
                            >
                                {importedBot
                                    ? <XIcon width={20} height={20} stroke="currentColor"/>
                                    : <ImportIcon width={20} height={20} stroke="currentColor"/>}
                                <Translate text={importedBot ? 'cancelImport' : 'import'}/>
                            </SilverButton>
                        }

                    </div>
            </Modal>
        );
    }

}

CreateClientModal.propTypes = {};

const mapDispatchToProps = dispatch => ({
    fetchCompany: () => {
        dispatch(fetchCompanyRequested());
    },
});

export default connect(null, mapDispatchToProps)(CreateClientModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/modals/CreateClientModal.jsx